import HttpRequest from "@/services/http_request";

class AcademicProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async getStudyPlan(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      programid: this.variableParser(request.programid),
      studyplanid: this.variableParser(request.studyplanid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/academic/studyplan");
    const { data } = res.data;
    return data;
  }
}

export default AcademicProvider;
